import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Link } from '@reach/router';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import TwitterIcon from '@material-ui/icons/Twitter';
import {
  GET_DEMO,
  TERMS_OF_USE,
  PRIVACY_POLICY,
  LINKED_IN_URL,
  TWITTER_URL,
} from '../constants/Paths';
import {
  BACKGROUND_BLACK,
  BLACK,
  TEXT_GREY,
  ORANGE,
  WHITE,
} from '../styles/Colors';
import {
  Mobile,
  Default,
} from './MediaQueryComponent';

const styles = () => ({
  screenContainer: {
    backgroundColor: WHITE,
    padding: '10px 10px 0 10px',
  },
  rowContainer: {
    display: 'flex',
    justifyContent: 'space-evenly',
  },
  unitContainer: {
    flex: 'auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: '20px 30px',
  },
  centerUnitContainer: {
    alignItems: 'center',
  },
  itemContainer: {
    flex: 'auto',
    display: 'flex',
    flexDirection: 'column',
  },
  titleText: {
    fontFamily: 'Roboto, sans-serif',
    fontSize: 14,
    color: BACKGROUND_BLACK,
    fontWeight: 'bold',
    marginBottom: 14,
  },
  normalItem: {
    fontFamily: 'Poppins, sans-serif',
    fontSize: 14,
    color: TEXT_GREY,
  },
  navItem: {
    fontFamily: 'Poppins, sans-serif',
    fontSize: 14,
    color: TEXT_GREY,
    textDecoration: 'none',
    '&:hover': {
      color: ORANGE,
    },
  },
  mobileNavItem: {
    textAlign: 'center',
  },
  iconItem: {
    margin: '0 6px',
  },
  buttonLikeStyle: {
    fontFamily: 'Roboto, sans-serif',
    fontSize: 16,
    color: WHITE,
    backgroundColor: ORANGE,
    borderRadius: 20,
    width: 120,
    padding: 8,
    textAlign: 'center',
    marginBottom: 14,
    '&:hover': {
      color: BLACK,
    },
  },
});

const Footer = ({
  classes,
}) => {
  const renderBasicInfo = (containerStyle = '', navItemStyle = '') => (
    <div className={`${classes.unitContainer} ${containerStyle}`}>
      <div className={classes.titleText}>
        Copyright © 2020 LinkedField Inc.
      </div>
      <div className={classes.itemContainer}>
        <div className={`${classes.normalItem} ${navItemStyle}`}>
          Santa Clara, CA
        </div>
        <a
          className={`${classes.navItem} ${navItemStyle}`}
          href="mailto:info@linkedfield.com"
        >
          info@linkedfield.com
        </a>
      </div>
    </div>
  );

  const renderMoreInfo = (containerStyle = '', navItemStyle = '') => (
    <div className={`${classes.unitContainer} ${containerStyle}`}>
      <div className={classes.titleText}>
        More Info
      </div>
      <div className={classes.itemContainer}>
        <Link
          className={`${classes.navItem} ${navItemStyle}`}
          to={PRIVACY_POLICY}
        >
          Privacy Policy
        </Link>
        <Link
          className={`${classes.navItem} ${navItemStyle}`}
          to={TERMS_OF_USE}
        >
          Terms of Use
        </Link>
      </div>
    </div>
  );

  const renderLearnMoreArea = () => (
    <div className={`${classes.unitContainer} ${classes.centerUnitContainer}`}>
      <Link
        className={`${classes.navItem} ${classes.buttonLikeStyle}`}
        to={GET_DEMO}
      >
        Learn more
      </Link>
      <div>
        <a
          className={`${classes.navItem} ${classes.iconItem}`}
          href={LINKED_IN_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          <LinkedInIcon fontSize="large" />
        </a>
        <a
          className={`${classes.navItem} ${classes.iconItem}`}
          href={TWITTER_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          <TwitterIcon fontSize="large" />
        </a>
      </div>
    </div>
  );

  return (
    <div className={classes.screenContainer}>
      <Mobile>
        {renderLearnMoreArea()}
        {renderBasicInfo(classes.centerUnitContainer, classes.mobileNavItem)}
        {renderMoreInfo(classes.centerUnitContainer, classes.mobileNavItem)}
      </Mobile>
      <Default>
        <div className={classes.rowContainer}>
          {renderBasicInfo()}
          {renderMoreInfo()}
          {renderLearnMoreArea()}
        </div>
      </Default>
    </div>
  );
};

Footer.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Footer);
